import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../data/interface";

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  Selection,
  rowKey,
  loading,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [enableSelection, setEnableSelection] = useState<boolean>(!!Selection);
  const [filteredDataSource, setFilteredDataSource] = useState<any[]>([]);

  // ✅ Handle row selection
  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  // ✅ Handle search/filter logic
  const handleSearch = (value: string) => {
    setSearchText(value);
    const filtered = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filtered);
  };

  // ✅ Sync filteredData with new incoming data
  useEffect(() => {
    setFilteredDataSource(dataSource || []);
  }, [dataSource]);

  // ✅ Update row selection toggle
  useEffect(() => {
    setEnableSelection(!!Selection);
  }, [Selection]);

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <>
      {/* 🔍 Search Bar */}
      <div className="table-top-data">
        <div className="row p-3">
          <div className="col-sm-12 col-md-6" />
          <div className="col-sm-12 col-md-6">
            <div className="dataTables_filter text-end mb-0">
              <label>
                <input
                  type="search"
                  className="form-control form-control-sm"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* 📋 Ant Design Table */}
      <Table
        className="table datanew dataTable no-footer"
        columns={columns}
        dataSource={filteredDataSource}
        rowSelection={enableSelection ? rowSelection : undefined}
        rowHoverable={false}
        rowKey={rowKey}
        loading={loading}
        pagination={{
          locale: { items_per_page: "" },
          nextIcon: <i className="ti ti-chevron-right" />,
          prevIcon: <i className="ti ti-chevron-left" />,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30"],
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total} entries`,
        }}
      />
    </>
  );
};

export default Datatable;
